import { render, staticRenderFns } from "./ShoppingCartItem.vue?vue&type=template&id=4b60480d&"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=ts&"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=ts&"
import style0 from "./ShoppingCartItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports